import React, { useRef, useState } from 'react';
import LogoDark from '../../assets/logo-dark.svg';
import LogoWhite from '../../assets/logo-white.svg';
import userApi from '../../services/userApi';
import tokenService from '../../utils/tokenService';
import Notification from '../../components/notification/notification';
import { useNavigate } from 'react-router-dom';
import ThemeChanger from '../../components/theme-changer/theme-changer';
import { TWInput, TWButton } from '../../components/ui';
import Turnstile from '../../components/turnstile/turnstile';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [notf, setNotf] = useState({
    display: false,
    type: 'error',
    message: '',
  });
  const [state, setState] = useState({ email: '', loading: false });
  const [errors, setErrors] = useState({ email: false });
  const [isDarkMode, setIsDarkMode] = useState(
    tokenService.getTheme() === 'dark',
  );
  const [turnstileToken, setTurnstileToken] = useState(null);
  const turnstileRef = useRef(null);

  const onClickSendEmail = async () => {
    if (state.email === '') {
      setErrors({ email: true });
      return;
    }
    setErrors({ email: false });
    setState((prev) => ({ ...prev, loading: true }));

    try {
      const res = await userApi.sendEmailForgotPassword(
        state.email,
        turnstileToken
      );
      if (res.data) {
        setNotf({
          display: true,
          type: 'success',
          message: 'Code has been sent to your email',
        });
      }
      navigate('/new-password?email=' + encodeURIComponent(state.email));
    } catch (error) {
      turnstileRef.current?.reset();
      setNotf({ display: true, type: 'error', message: error });
    } finally {
      setState((prev) => ({ ...prev, loading: false }));
    }
  };

  return (
    <div className="relative flex h-screen flex-col justify-center bg-slate-50 py-12 px-6 dark:bg-slate-900 lg:px-8">
      <ThemeChanger
        position="right-5 top-5 absolute"
        onChange={setIsDarkMode}
      />
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <img
          onClick={() => navigate('/')}
          className="mx-auto h-16 w-auto cursor-pointer"
          src={isDarkMode ? LogoWhite : LogoDark}
          alt="Thisway"
        />
        <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-slate-900 dark:text-slate-100">
          Forgot Password
        </h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="rounded-md border border-slate-200 bg-white px-6 py-8 shadow-sm dark:border-slate-700 dark:bg-slate-800 sm:px-10">
          <div className="space-y-5">
            <TWInput
              label="Email address"
              type="email"
              autoComplete="email"
              required
              value={state.email}
              onChange={(e) =>
                setState((prev) => ({ ...prev, email: e.target.value }))
              }
              error={errors.email ? 'Enter your email' : undefined}
            />
            <Turnstile ref={turnstileRef} onToken={setTurnstileToken} />
            <TWButton
              variant="primary"
              block
              size="lg"
              label="Send E-mail"
              loading={state.loading}
              disabled={state.loading}
              onClick={onClickSendEmail}
            />
          </div>
        </div>
      </div>

      <Notification
        display={notf.display}
        type={notf.type}
        message={notf.message}
        onClose={() => setNotf((prev) => ({ ...prev, display: false }))}
      />
    </div>
  );
};

export default ForgotPassword;
